module.exports = __webpack_public_path__ + "img/sb.7c6de119.jpg";